export class FetchTomTomShapeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FetchTomTomShapeError';
    }
}
